import { message } from '@nackle/paper';
import { clientFetch } from '@nackle/salesmaker-client-fetch';
import auth from 'app/auth';
import get from 'lodash/get';

const clientFetchWithCatch = (opts: any) => clientFetch(opts).catch(
    (error: any) => {
        const code = error.responseCode;
        const responseContentReason = get(error, 'responseContent.reason', false);

        if (code === 401) {
            auth.signOut();
        } else if (responseContentReason) {
            message.success({ content: responseContentReason });
        } else {
            message.error({ content: 'An error occurred. Please notify the #compound-arcade channel.' });
        }

        throw error;
    },
);

export { clientFetchWithCatch as clientFetch };
